<app-payment-document-value
  *ngFor="let dv of paymentTable.getPaid(); let i = index; trackBy: trackByFn"
  documentPlaceHolder="{{ getPlaceHolder(i) }}"
  [documents]="getAvailableDocuments(dv)"
  [documentValue]="dv"
  (valueChange)="onPaidValueChange($event)"
  (completeClicked)="onCompleteClicked($event)"
  [focused]="isFocused(dv)"
>
</app-payment-document-value>
